var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GridEditor } from "@/components/studio/studio/components/layouts/grid-editor/gridEditor";
import { ListEditor } from "@/components/studio/studio/components/layouts/list-editor/listEditor";
import { useGetModuleBuilderLayoutsQuery } from "@/store/api";
export var LayoutEditor = function () {
    var _a = useParams(), packagesName = _a.packagesName, moduleName = _a.moduleName, type = _a.type, menu = _a.menu, dropdownName = _a.dropdownName, fieldName = _a.fieldName;
    var _b = useGetModuleBuilderLayoutsQuery({
        params: {
            package: "",
            module: moduleName,
        },
    }), list_layouts = _b.data, isLoading = _b.isLoading;
    var _c = useState([]), layouts = _c[0], setLayouts = _c[1];
    var fetchLayouts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (list_layouts) {
                setLayouts((_a = list_layouts === null || list_layouts === void 0 ? void 0 : list_layouts.data) === null || _a === void 0 ? void 0 : _a.layouts);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        fetchLayouts();
    }, [list_layouts]);
    var packageName = packagesName !== "default" ? packagesName : "";
    var layoutInfo = fieldName && layouts[fieldName];
    if (!layoutInfo || !layoutInfo.name) {
        return null; // or some fallback UI
    }
    var LayoutComponent = layoutInfo.type === "grid" ? GridEditor : ListEditor;
    return (_jsx(_Fragment, { children: _jsx(LayoutComponent, { layoutName: layoutInfo.name, packageName: packageName || "", moduleName: moduleName || "" }) }));
};
